module.exports = __webpack_public_path__ + "static/media/visual_studio.b8ad169d.png";